(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ol-vault-team-clubs"] && !Shopify.designMode) return;
  try {
    
(function(){function init(){document.querySelectorAll('.ol-vteam-clubdir').forEach(function(root){if(root.dataset.directoryReady)return;root.dataset.directoryReady='true';var track=root.querySelector('.ol-vteam-clubdir-grid');var prev=root.querySelector('[data-vault-directory-prev]');var next=root.querySelector('[data-vault-directory-next]');function move(direction){track.scrollBy({left:direction*track.clientWidth,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}prev.addEventListener('click',function(){move(-1)});next.addEventListener('click',function(){move(1)});});}init();document.addEventListener('shopify:section:load',init);})();

  } catch(e) { console.error(e); }
})();
})();
